module.exports = __webpack_public_path__ + "media/dashboard/assets/icons/ic_warning-20184259bc6a59425da121e0719c82e8.svg";